import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/VolumeLevel0.svg'

export const IconVolumeLevel0 = IconSVG as IconComponent
